import React from 'react';
import AccountSearchPanel from '../features/accountSearch/AccountSearchPanel';
import '../features/accountSearch/accountSearch.css';

export default function DashboardPage() {
  return (
    <div className="page account-search-page">
      <header className="account-search-header">
        <div>
          <h2>Account Search</h2>
          <p>Search account and device records across OneCloud regions.</p>
        </div>
      </header>
      <AccountSearchPanel />
    </div>
  );
}
